import { createContext } from 'react';

export const CookieConsentContext = createContext(undefined);
